<template>
  <DataIterat
    :headless="fetching"
    :searchable="searchable"
    :filterable="filterable && meta && meta.last_page > 1"
    :filter-presets="filterPresets"
    :bulk-actionable="bulkActionable && meta && meta.total > 1"
    :actionable="actionable"
    :paginatable="meta && meta.last_page !== 1"
    v-bind="{ items: pages, loading: fetching, meta }"
    v-on="{ getData: getPages }"
  >
    <DataIteratHeaderContent slot="list-header-content" />
    <DataIteratItemContent slot="list-item-content" slot-scope="{ dataItem: page }" :page="page">
      <template>
        <slot name="item-title" :page="page" />
      </template>
    </DataIteratItemContent>
    <template #list-item-actions="{ dataItem, onClick }">
      <slot name="item-actions" :page="dataItem" :action-clicked="onClick" />
    </template>
  </DataIterat>
</template>

<script>
import DataIterat from '@/components/Ui/DataIterat.vue';
import DataIteratHeaderContent from './DataIteratHeaderContent.vue';
import DataIteratItemContent from './DataIteratItemContent.vue';

export default {
  name: 'PageList',
  components: {
    DataIterat,
    DataIteratHeaderContent,
    DataIteratItemContent,
  },
  props: {
    fetching: Boolean,
    searchable: Boolean,
    filterable: Boolean,
    filterPresets: {
      type: Array,
      default: () => [],
    },
    actionable: Boolean,
    bulkActionable: Boolean,
    pages: {
      type: Array,
      default: () => [],
    },
    meta: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    getPages(queryParams = {}) {
      this.$emit('get-pages', queryParams);
    },
  },
};
</script>
